import * as React from 'react';
/**
 * An utility function for asynchronous focus/blur handling.
 *
 * By default, the `onFocus` and `onBlur` callbacks are called every time a child components receives/loses focus.
 * Use this utility hook for scenarios where you need to know if the parent has received focus for the first time, or completely lost focus.
 *
 * @returns
 */
export function useAsyncFocusBlur(_a) {
    var onFocus = _a.onFocus, onBlur = _a.onBlur, onSyncFocus = _a.onSyncFocus, onSyncBlur = _a.onSyncBlur;
    var focused = React.useRef(false);
    var tick = React.useRef(0);
    var nextTick = React.useCallback(function (f) {
        clearTimeout(tick.current);
        tick.current = window.setTimeout(function () { return f(); });
    }, [tick]);
    var handleFocus = React.useCallback(function () {
        var event = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            event[_i] = arguments[_i];
        }
        clearTimeout(tick.current);
        if (onSyncFocus) {
            onSyncFocus.call.apply(onSyncFocus, [undefined].concat(event));
        }
        if (focused.current) {
            return;
        }
        ;
        focused.current = true;
        if (onFocus) {
            onFocus.call.apply(onFocus, [undefined].concat(event));
        }
    }, [focused, onFocus, onSyncFocus]);
    var handleBlur = React.useCallback(function () {
        var event = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            event[_i] = arguments[_i];
        }
        if (onSyncBlur) {
            onSyncBlur.call.apply(onSyncBlur, [undefined].concat(event));
        }
        nextTick(function () {
            if (!focused.current) {
                return;
            }
            if (onBlur) {
                focused.current = false;
                onBlur.call.apply(onBlur, [undefined].concat(event));
            }
        });
    }, [focused, nextTick, onBlur, onSyncBlur]);
    return {
        onFocus: handleFocus,
        onBlur: handleBlur
    };
}
//# sourceMappingURL=useAsyncFocusBlur.js.map